import React, { useState, useEffect } from 'react';
import {
    pushSupporte,
    etatAutorisation,
    activerPush,
    estIOS,
    estModeApplication,
} from '../services/push';

// ═══════════════════════════════════════════════════════════════════
//  Rappel d'activation des notifications
//
//  Le bandeau de la cloche ne se voit qu'en ouvrant la cloche : un membre
//  qui n'y pense pas ne découvrira jamais la fonctionnalité. Ce rappel-ci
//  s'affiche directement sur la page des profils.
//
//  Il disparaît définitivement dès que le membre l'active ou le ferme :
//  un rappel qui revient à chaque visite devient une nuisance.
// ═══════════════════════════════════════════════════════════════════

const CLE_MASQUE = 'zt_rappel_notifications_masque';

const RappelNotifications = () => {
    const [visible, setVisible] = useState(false);
    const [message, setMessage] = useState('');
    const [iosAInstaller, setIosAInstaller] = useState(false);

    useEffect(() => {
        let masque = false;
        try {
            masque = localStorage.getItem(CLE_MASQUE) === '1';
        } catch (err) {
            // Navigation privée ou stockage refusé : on affiche, sans plus.
        }
        if (masque) return;

        const ios = estIOS() && !estModeApplication();
        setIosAInstaller(ios);

        // Sur iPhone hors écran d'accueil, pushSupporte() est faux alors que
        // le membre PEUT recevoir des notifications après la manipulation.
        // On affiche donc le rappel dans ce cas aussi.
        if (ios || (pushSupporte() && etatAutorisation() !== 'granted')) {
            setVisible(true);
        }
    }, []);

    const fermer = () => {
        setVisible(false);
        try {
            localStorage.setItem(CLE_MASQUE, '1');
        } catch (err) {
            // Sans stockage, le rappel reviendra à la prochaine visite.
        }
    };

    const activer = async () => {
        setMessage('Activation en cours...');
        const r = await activerPush();
        if (r.ok) {
            fermer();
        } else {
            setMessage(r.message);
        }
    };

    if (!visible) return null;

    return (
        <div style={styles.bandeau}>
            <div style={styles.contenu}>
                <span style={styles.titre}>Ne manquez plus rien</span>
                <span style={styles.texte}>
                    Activez les notifications pour être prévenu des nouveaux messages,
                    des demandes de mise en relation, des intérêts reçus et de la fin
                    d'un échange — même lorsque le site est fermé.
                </span>

                {iosAInstaller ? (
                    <span style={styles.texteIos}>
                        Sur iPhone : appuyez sur le bouton Partager en bas de Safari,
                        choisissez « Sur l'écran d'accueil », puis ouvrez le site depuis
                        cette nouvelle icône.
                    </span>
                ) : (
                    <button onClick={activer} style={styles.bouton}>
                        Activer les notifications
                    </button>
                )}

                {message && <span style={styles.message}>{message}</span>}
            </div>

            <button onClick={fermer} style={styles.fermer} title="Masquer ce rappel">
                ✕
            </button>
        </div>
    );
};

const styles = {
    bandeau: {
        display: 'flex', alignItems: 'flex-start', justifyContent: 'space-between',
        gap: '12px', padding: '16px 18px', marginBottom: '18px',
        backgroundColor: 'rgba(192,48,106,0.06)',
        border: '1px solid #ecd9b9', borderRadius: '14px',
        boxSizing: 'border-box',
    },
    contenu: { display: 'flex', flexDirection: 'column', gap: '8px', minWidth: 0 },
    titre: { color: '#4a0028', fontSize: '15px', fontWeight: '700' },
    texte: { color: '#6b4a5a', fontSize: '13.5px', lineHeight: '1.5' },
    texteIos: { color: '#7a1340', fontSize: '13px', lineHeight: '1.5', fontWeight: '600' },
    bouton: {
        alignSelf: 'flex-start', marginTop: '4px',
        padding: '9px 18px', borderRadius: '9px', border: 'none',
        backgroundColor: '#4a0028', color: '#ffffff',
        fontSize: '13px', fontWeight: '700', cursor: 'pointer',
    },
    message: { color: '#7a1340', fontSize: '12.5px', lineHeight: '1.45' },
    fermer: {
        flexShrink: 0, background: 'transparent', border: 'none',
        color: '#9a7d88', fontSize: '16px', cursor: 'pointer',
        padding: '2px 6px', lineHeight: 1,
    },
};

export default RappelNotifications;
